/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-intl';
import LabelError from '../../Label/ErrorForm';
import { Wrapper } from './style';

export const privacyPolicyPath = locale =>
	locale === 'en' ? '/en/privacy-policy' : '/privacy-policy?lang=id';

/**
 * Explicit, unchecked-by-default consent checkbox for personal data processing
 * (UU No. 27 Tahun 2022 tentang Pelindungan Data Pribadi, Pasal 20-22).
 * Must be rendered on every form that collects personal data.
 */
const InputConsent = ({
	className,
	name,
	idInput,
	checked,
	onChange,
	isError,
	textError,
	nativeRequired,
}) => {
	const intl = useIntl();

	return (
		<Wrapper className={className || 'consentDefault'}>
			<label className={isError ? 'consentLabel invalidForm' : 'consentLabel'} htmlFor={idInput}>
				<input
					type="checkbox"
					id={idInput}
					name={name}
					value="yes"
					checked={checked}
					onChange={onChange}
					required={nativeRequired}
				/>
				<span className="consentText">
					{intl.formatMessage({ id: 'consent.text_before' })}{' '}
					<a href={privacyPolicyPath(intl.locale)} target="_blank" rel="noopener noreferrer">
						{intl.formatMessage({ id: 'consent.link' })}
					</a>{' '}
					{intl.formatMessage({ id: 'consent.text_after' })}
				</span>
			</label>
			{isError && (
				<LabelError>
					{textError || intl.formatMessage({ id: 'validate_form.consent_required' })}
				</LabelError>
			)}
		</Wrapper>
	);
};

InputConsent.defaultProps = {
	className: '',
	name: undefined,
	isError: false,
	textError: '',
	nativeRequired: false,
};

InputConsent.propTypes = {
	className: PropTypes.string,
	name: PropTypes.string,
	idInput: PropTypes.string.isRequired,
	checked: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired,
	isError: PropTypes.bool,
	textError: PropTypes.string,
	nativeRequired: PropTypes.bool,
};

export default InputConsent;
